import videoTutorialUrls from "@/config/video-tutorial-urls";
import { Module } from "@/enums/modules";

export const videoTutorialsMixin = {
  data() {
    return {
      viewEnum: Module
    };
  },
  methods: {
    showVideoTutorial(viewName) {
      this.$store.dispatch("settings/setVideoModal", {
        isOpen: true,
        ...videoTutorialUrls[viewName]
      });
    }
  }
};
